<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 text-muted">MAPPING ENGINE / OUTBOUND RULESETS</h1>
      <button
        type="button"
        class="btn btn-primary"
        @click="$router.push('/addoutboundruleset')"
        id="but"
      >
        Add Ruleset
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Outbound Ruleset Name</th>
          <th scope="col">Calculator</th>
          <th scope="col">Insurer</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="ruleset in rulesets"
          :key="ruleset.ruleset_id"
          @click="$router.push('/editoutboundruleset/' + ruleset.ruleset_id)"
          class="clickable-row"
        >
          <td>{{ ruleset.mapping_ruleset_name }}</td>
          <td>{{ ruleset.calculator_name }}</td>
          <td>{{ ruleset.insurer_name }}</td>
          <td>
            <span v-if="ruleset.active" class="badge bg-success">Active</span>
            <span v-else class="badge bg-danger">Inactive</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      rulesets: [],
    };
  },
  async mounted() {
    const response = await fetch(config.baseURL + "/get_mapping_rulesets", {
      credentials: "include",
    });
    const data = await response.json();
    console.log(data);
    this.rulesets = data;
  },
};
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}
</style>
